/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation view
**********************************************************/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Line, Bar } from 'react-chartjs-2';
import { initLineChart, initBarChart } from '../harvest_utils';
import { generateGraphDataAndLabels } from '../utils';
import IrrigationIntroSummary from './components/dashboard/irrigation_intro_summary';
import MeterSummary from './components/dashboard/meter_summary';
const propTypes = {
  dashboardData: PropTypes.object
};

class IrrigationDashboard extends Component {
  render() {
    let { engineTotals, meterTotals, valveTotals, fieldTotals, blockTotals } = this.props.dashboardData;
    /* Line Chart: By Engine */
    let line_2 = generateGraphDataAndLabels('totalFuelCost', 'key', engineTotals);
    let line_3 = generateGraphDataAndLabels('totalGal', 'key', fieldTotals);
    /* Bar Chart: Gal by valve */
    let bar_1 = generateGraphDataAndLabels('totalGal', 'key', valveTotals);
    let bar_2 = generateGraphDataAndLabels('totalGal', 'key', blockTotals);

    return (
      <div>
        {
          engineTotals.length > 0 ?
          <div>
            <IrrigationIntroSummary engineTotals={engineTotals} meterTotals={meterTotals} valveTotals={valveTotals} />
            <div className="row">
              <div className="col s12 m6 l6 xl6">
                <div className="card z-depth-4">
                  <span className="card-title grey-text text-darken-4">Gallons by Valve</span>
                  <div className="card-image">
                    <Bar data={initBarChart({label: 'Total Gallons by Valve', labels: bar_1.labels, data: bar_1.data, backgroundColor: '#42a5f5',
                      borderColor: '#1565c0 ', borderWidth: 1, hoverBackgroundColor: '#e3f2fd', hoverBorderColor: '#90caf9' })}
                      height={300}
                      options={{
                        maintainAspectRatio: false
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col s12 m6 l6 xl6">
                <div className="card z-depth-4">
                  <span className="card-title grey-text text-darken-4">Fuel Cost by Engine</span>
                  <div className="card-image">
                    <Line
                      data={initLineChart({ label: 'Total Cost by Engine', labels: line_2.labels, data: line_2.data, backgroundColor: '#00897b' })}
                      height={300}
                      options={{
                        maintainAspectRatio: false
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col s12 m6 l6 xl6">
                <div className="card z-depth-4">
                  <span className="card-title grey-text text-darken-4">Gallons by Field</span>
                  <div className="card-image">
                    <Line
                      data={initLineChart({ label: 'Total Gallons by Field', labels: line_3.labels, data: line_3.data, backgroundColor: '#9c27b0' })}
                      height={300}
                      options={{
                        maintainAspectRatio: false,
                        fill: true
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col s12 m6 l6 xl6">
                <div className="card z-depth-4">
                  <span className="card-title grey-text text-darken-4">Gallons by Block</span>
                  <div className="card-image">
                    <Bar data={initBarChart({label: 'Total Gallons by Block', labels: bar_2.labels, data: bar_2.data, backgroundColor: '#8bc34a',
                      borderColor: '#33691e ', borderWidth: 1, hoverBackgroundColor: '#aed581', hoverBorderColor: '#dcedc8vv' })}
                      height={300}
                      options={{
                        maintainAspectRatio: false
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col s12 m12 l12 xl12">
                <div className="card z-depth-4">
                  <MeterSummary meterTotals={meterTotals} />
                </div>
              </div>
            </div>

          </div>
          : <div><h5>No irrigation data exists for the date range.</h5></div>
        }
      </div>
    )
  }
}


IrrigationDashboard.propTypes = propTypes;
export default IrrigationDashboard;

























/* END */



// WEBPACK FOOTER //
// ./src/irrigation/irrigation_dashboard.js